<template>
  <div>
    <v-combobox
        :filled="!!filled"
        v-model="currentValue"
        :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-tag-text-outline' : ''"
        :search-input.sync="search"
        :items="items"
        item-text="name"
        item-value="id"
        hide-selected
        multiple
        :menu-props="{ closeOnContentClick: !!closeOnContentClick }"
        :label="$t('label')"
        :rules="rules"
        hide-details
        @keyup.enter.prevent="$emit('enter')"
    >
      <template v-slot:selection="data">
        <v-chip
            small
            :key="JSON.stringify(data.item)"
            :color="data.item.color || '#1976D2'"
            :dark="!$helpers.color.isLight(data.item.color || '#1976D2')"
            close
            @click:close="data.parent.selectItem(data.item)"
        >
          {{ data.item.name || data.item }}
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        {{ item.name || item }}
        <v-spacer></v-spacer>
        <v-chip v-if="typeof item === 'string'" label outlined color="blue darken-2" small>{{ $t('new') }}</v-chip>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'TagsSelect',
  props: ['value', 'filled', 'closeOnContentClick'],
  data () {
    return {
      currentValue: this.value,
      tags: this.$repos.tags.createFullCollection(),
      fetching: false,
      search: '',
      rules: [
        v => !!v || this.$t('required'),
      ]
    }
  },
  computed: {
    items () {
      return [this.search, ...this.tags.all]
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    },
    search (search) {
      this.fetching = true
      this.fetch(this, search)
    }
  },
  methods: {
    fetch: debounce(async (self, search) => {
      search = search ? search : ''
      await self.tags.fetch('where[name][like]=%' + search + '%&limit=10')
      self.fetching = false
    }, 250)
  },
  destroyed () {
    this.tags.destroy()
  }
}
</script>

<i18n>
{
	"en": {
		"label": "Tags",
		"new": "New"
	},
	"es": {
		"label": "Etiquetas",
		"new": "Nuevo"
	},
	"fr": {
		"label": "Tags",
		"new": "Nouveau"
	},
	"it": {
		"label": "Tag",
		"new": "Nuovo"
	},
	"pt": {
		"label": "Tags",
		"new": "Novo"
	},
	"pl": {
		"label": "Tagi",
		"new": "Nowe"
	}
}
</i18n>